const primaryMain = '#000000';
const primaryMainOpacity = 'rgba(0, 0, 0, 0.9)';
const secondaryMain = '#E82E21';
const secondaryMainOpacity = 'rgba(232, 46, 33, 0.5)';
const secondaryLight = '#E82E21';
const tertiaryMain = '#414042';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
